import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-family-member-det-cm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-family-member-det-cm.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { AppControllerService } from "../../../../app-controller.service";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import RecipientUtils from "../../../../shared/utils/recipient-utils";
import { CreateFamillyMemberConstant } from "./create-familly-member-det.constants";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
let CreateFamilyMemberDetCmComponent = class CreateFamilyMemberDetCmComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    changeDetectorRefs;
    searchApplicationsService;
    familyMemberForm = new FormGroup({});
    familyMemberGroups = [];
    familyMemberShowGroupsDropdown = false;
    familyMemberDisableAdd = false;
    familyMemberDisableFilterBy = true;
    familyMemberDisableEditing = false;
    familyMemberListLabel = CreateFamillyMemberConstant.FAMILY_LABEL;
    familyMemberListControl = CreateFamillyMemberConstant.FAMILY_CONTROL;
    copyApplicantToFamilyLabel = CreateFamillyMemberConstant.COPY_APPLICANT_TO_FAMILY_LABEL;
    applicants;
    family = [];
    selectedApplicationCreateFamilyMemberSubscription;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appControllerService, changeDetectorRefs, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.searchApplicationsService = searchApplicationsService;
        this.initForm();
    }
    ngOnInit() {
        this.getMetadata();
    }
    loadMetadata(stepMeta) {
        this.familyMemberGroups = stepMeta.familyGroup;
        this.subscribeToSelectedApplication();
    }
    onBtnCopyApplicantToFamilyClicked() {
        if (!this.applicants)
            return;
        this.family = null;
        const family = this.familyMemberForm.get(this.familyMemberListControl).value;
        if (family && family.length > 0)
            this.family = family;
        else
            this.family = [];
        this.applicants.forEach((applicant) => {
            applicant.id = 0;
            applicant.groups = [{
                    groupName: this.stepMeta.familyGroup[0].GroupName,
                    groupType: this.stepMeta.familyGroup[0].GroupType,
                }];
        });
        this.family.push(...this.applicants);
        const familyMemberListControl = this.familyMemberForm.get(this.familyMemberListControl);
        RecipientUtils.setRecipients(this.family, true, familyMemberListControl);
    }
    populateForm(application) {
        if (application && application.appId > 0) {
            this.familyMemberForm.markAllAsTouched();
        }
        const familyMemberListControl = this.familyMemberForm.get(this.familyMemberListControl);
        const family = application.family.filter(f => !f.deleted);
        RecipientUtils.setRecipients(family, true, familyMemberListControl);
        this.changeDetectorRefs.detectChanges();
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationCreateFamilyMemberSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.populateForm(application);
                this.getApplicant(application);
            }
        });
    }
    refreshTableIndexes() {
        for (let index = 0; index < this.family.length; index++) {
            if (this.family[index].id > 0) {
                this.family[index].id = index !== 0 ? -index : 0;
            }
        }
    }
    initForm() {
        this.familyMemberForm = this.aflaModuleStrategyService.form.get("familyMemberForm");
        this.familyMemberForm.enable();
    }
    getApplicant(app) {
        this.applicants = app.applicant;
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
};
CreateFamilyMemberDetCmComponent = __decorate([
    Component({
        selector: "app-create-family-member-det-cm",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateFamilyMemberDetCmComponent);
export { CreateFamilyMemberDetCmComponent };
